import { HttpErrorResponse } from '@angular/common/http';
import { Action } from '@ngrx/store';
import { WarehouseSubLocation } from './warehouse-sub-location.model';

export const ADD = '[WarehouseSubLocation] Add';
export const ADD_COMPLETE = '[WarehouseSubLocation] Add Complete';
export const ADD_FAILED = '[WarehouseSubLocation] Add Failed';

export const DELETE = '[WarehouseSubLocation] Delete';
export const DELETE_COMPLETE = '[WarehouseSubLocation] Delete Complete';
export const DELETE_FAILED = '[WarehouseSubLocation] Delete Failed';

export const UPDATE = '[WarehouseSubLocation] Update';
export const UPDATE_COMPLETE = '[WarehouseSubLocation] Update Complete';
export const UPDATE_FAILED = '[WarehouseSubLocation] Update Failed';

export class AddAction implements Action {
    readonly type = ADD;

    constructor(public payload: WarehouseSubLocation) { }
}

export class AddCompleteAction implements Action {
    readonly type = ADD_COMPLETE;
    constructor(public payload: WarehouseSubLocation) { }
}

export class AddFailedAction implements Action {
    readonly type = ADD_FAILED;

    constructor(public payload: { error: any }) { }
}

export class DeleteAction implements Action {
    readonly type = DELETE;

    constructor(public payload: WarehouseSubLocation) { }
}

export class DeleteCompleteAction implements Action {
    readonly type = DELETE_COMPLETE;

    constructor(public payload: WarehouseSubLocation) { }
}

export class DeleteFailedAction implements Action {
    readonly type = DELETE_FAILED;

    constructor(public payload: { error: HttpErrorResponse }) { }
}

export class UpdateAction implements Action {
    readonly type = UPDATE;

    constructor(public payload: WarehouseSubLocation) { }
}

export class UpdateCompleteAction implements Action {
    readonly type = UPDATE_COMPLETE;
    constructor(public payload: WarehouseSubLocation) { }
}

export class UpdateFailedAction implements Action {
    readonly type = UPDATE_FAILED;

    constructor(public payload: { error: any }) { }
}

export type Actions
    = AddAction
    | AddCompleteAction
    | AddFailedAction
    | DeleteAction
    | DeleteCompleteAction
    | DeleteFailedAction
    | UpdateAction
    | UpdateCompleteAction
    | UpdateFailedAction;
